export enum CalendarTypeOfView {
  MONTH = 'Month',
  WEEK = 'Week',
  DAY = 'Day',
  SCHEDULE = 'Schedule',
}
